import * as React from "react";
import { Outlet, createRootRoute } from "@tanstack/react-router";
import { AsyncStorageKeyEnum } from "@/enum";
import {  store } from "@/store";
import { userApi } from "@/features/user";
import { storeApi } from "@/features/business";
import { authApi, clearAll } from "@/features/auth";
import { electronService } from "@/services/electronService";
import MandatoryUpdateOverlay from "@/components/common/MandatoryUpdateOverlay";
import UpdateReadyPopup from "@/components/common/UpdateReadyPopup";
import TitleBar from "@/components/common/TitleBar";
import { AutoUpdateProvider } from "@/context/AutoUpdateContext";

export const Route = createRootRoute({
  beforeLoad: async () => {
    try {
      let currentUserData: any = null;
      const response = localStorage.getItem(AsyncStorageKeyEnum.CurrentUser);
      currentUserData = response ? JSON.parse(response) : null;
      if (currentUserData) {
        await store.dispatch(userApi.endpoints.userSelf.initiate(undefined));
        if (currentUserData.profileType === 'Store') {
          const res = await store.dispatch(storeApi.endpoints.storeSelf.initiate('')).unwrap();
          localStorage.setItem(
            AsyncStorageKeyEnum.CurrentUser,
            JSON.stringify({ ...res, profileType: 'Store' })
          );
        } else {
          // A storeless user's my-store call can fail; that must NOT clear the
          // session (otherwise guarded routes like /store/create bounce to login).
          try {
            const storeList = await store.dispatch(storeApi.endpoints.storeList.initiate('seller=true')).unwrap();
            if (storeList?.length) {
              await store.dispatch(authApi.endpoints.changeProfile.initiate({
                storeId: storeList[0]._id,
                self: false,
              }));
            }
          } catch {
            // No stores yet — keep the User-profile session intact.
          }
        }
      }
    } catch (error) {
      store.dispatch(clearAll());
    }
  },
  component: RootComponent,
});

function RootComponent() {
  React.useEffect(() => {
    // Optionally fetch printers here if needed, but no logs
    electronService.getPrinters().catch(console.error);
  }, []);

  return (
    <React.Fragment>
      <TitleBar />
      <AutoUpdateProvider>
        <div className={`${electronService.isElectron() ? "pt-8" : ""} min-h-screen`}>
          <MandatoryUpdateOverlay />
          <UpdateReadyPopup />
          <Outlet />
        </div>
      </AutoUpdateProvider>
    </React.Fragment>
  );
}
